// English translations for the layout templates pages (French string -> English).
// Covers AdminLayoutTemplatesPage.tsx + templates/SlotReviewPane.tsx.
// Shared strings (Annuler, Supprimer, Rechercher, Chargement…, Tout) live in
// common.ts and are intentionally NOT duplicated here.
const m: Record<string, string> = {
  // Album categories (shared by both pages)
  'Voyage': 'Travel',
  'Bébé': 'Baby',
  'Mariage': 'Wedding',
  'Anniversaire': 'Birthday',
  'Diplôme': 'Graduation',
  'Animaux': 'Pets',
  'Famille': 'Family',
  'Religieux': 'Religious',

  // AdminLayoutTemplatesPage — header & actions
  'Modèles de page': 'Page templates',
  '{n} modèle': '{n} template',
  '{n} modèles': '{n} templates',
  ' pour « {query} »': ' for “{query}”',
  'Sélectionner': 'Select',
  'Sélection ({n})': 'Selection ({n})',
  '+ Ajouter un modèle': '+ Add a template',

  // AdminLayoutTemplatesPage — bulk action bar
  '{n} sélectionné(e)s': '{n} selected',
  'Visibles': 'Visible',
  'Masquer': 'Hide',
  'AI ✓': 'AI ✓',
  'AI ✗': 'AI ✗',
  'Catégorie…': 'Category…',

  // AdminLayoutTemplatesPage — alerts & confirms
  '{n} échec(s). Les autres ont réussi.': '{n} failure(s). The rest succeeded.',
  'Erreur : {message}': 'Error: {message}',
  'inconnue': 'unknown',
  'Supprimer {n} modèle(s) ?': 'Delete {n} template(s)?',

  // AdminLayoutTemplatesPage — search & filters
  'Rechercher un modèle (nom, tag, description)…': 'Search a template (name, tag, description)…',
  'Tous': 'All',

  // AdminLayoutTemplatesPage — empty state
  'Aucun modèle': 'No templates',
  'Téléversez votre premier modèle pour commencer.': 'Upload your first template to get started.',

  // AdminLayoutTemplatesPage — template card
  'Masqué': 'Hidden',
  'IA': 'AI',
  'Sans catégorie': 'Uncategorized',
  '{n} zone': '{n} zone',
  '{n} zones': '{n} zones',

  // SlotReviewPane — batch header
  'Template': 'Template',
  'sur': 'of',
  '{n} restant après celui-ci': '{n} remaining after this one',
  '{n} restants après celui-ci': '{n} remaining after this one',

  // SlotReviewPane — header
  '← Retour aux modèles': '← Back to templates',
  'Modifier le template': 'Edit template',
  'Réviser les emplacements photo': 'Review photo slots',
  'Fichier :': 'File:',
  '{n} élément détecté': '{n} element detected',
  '{n} éléments détectés': '{n} elements detected',
  'Classification en cours…': 'Classifying…',
  'Relancer la classification IA': 'Re-run AI classification',
  'Relancer la classification IA va réinitialiser vos modifications manuelles. Continuer ?':
    'Re-running AI classification will reset your manual changes. Continue?',
  'Classification IA indisponible — marquez chaque élément manuellement.':
    'AI classification unavailable — mark each element manually.',

  // SlotReviewPane — metadata form
  'Informations du modèle': 'Template information',
  'Nom': 'Name',
  'Slug': 'Slug',
  'Catégorie': 'Category',
  'Visible dans la galerie': 'Visible in the gallery',
  'Éligible à l’IA': 'Eligible for AI',

  // SlotReviewPane — slot tier
  'Emplacements photo — {n} détecté': 'Photo slots — {n} detected',
  'Emplacements photo — {n} détectés': 'Photo slots — {n} detected',
  'Aucun emplacement photo classifié pour l’instant.': 'No photo slots classified yet.',

  // SlotReviewPane — uncertain tier
  'Incertains — {n} à confirmer': 'Uncertain — {n} to confirm',
  'L’IA n’a pas pu décider avec assez de certitude. Marquez chaque élément ci-dessous.':
    'The AI could not decide with enough certainty. Mark each element below.',

  // SlotReviewPane — hidden decorations tier
  'Masquer {n} décoration masquée': 'Hide {n} hidden decoration',
  'Masquer {n} décorations masquées': 'Hide {n} hidden decorations',
  'Afficher {n} décoration masquée': 'Show {n} hidden decoration',
  'Afficher {n} décorations masquées': 'Show {n} hidden decorations',

  // SlotReviewPane — save bar
  'Marquez au moins 1 emplacement photo': 'Mark at least 1 photo slot',
  'Confirmez {n} élément(s) incertain(s)': 'Confirm {n} uncertain element(s)',
  'Enregistrement…': 'Saving…',
  'Enregistrer le template ({n} emplacement)': 'Save template ({n} slot)',
  'Enregistrer le template ({n} emplacements)': 'Save template ({n} slots)',

  // SlotReviewPane — preview modal & slot card
  'Aperçu agrandi': 'Enlarged preview',
  'Agrandir {id}': 'Enlarge {id}',
  'Emplacement': 'Slot',
  'Décoration': 'Decoration',
  'Monter': 'Move up',
  'Descendre': 'Move down',
  'IA :': 'AI:',
  // « Thème de l'album » bar (components/theme/ThemeBar.tsx)
  'Thèmes': 'Themes',
  'Thème de l’album': 'Album theme',
  'Thème': 'Theme',
  'Coloris': 'Colourway',
  'coloris': 'colourway',
  'Couleur': 'Colour',
  'Couleur du thème': 'Theme colour',
  'Autre couleur': 'Other colour',
  'du coloris': 'colourway’s own',
  'Pages avec modèle': 'Pages with a model',
  'Modèles différents': 'Different models',
  'modèles': 'models',
  'par défaut': 'default',
  'Revenir au réglage par défaut ({n})': 'Back to the default ({n})',
  'couverture': 'cover',
  'Sans thème': 'No theme',
  'Enregistré': 'Saved',
  'Échec — réessayer': 'Failed — retry',
  'Régénération…': 'Regenerating…',
  'Appliquer : Régénérer': 'Apply: Regenerate',
  'à la prochaine mise en page': 'at the next layout',
  'Enregistré — à la prochaine mise en page': 'Saved — at the next layout',
  'Thèmes désactivés (interrupteur général) : aucun album ne reçoit de thème pour l’instant.': 'Themes switched off (master switch): no album gets a theme for now.',
  'Inactif — aucun album ne le reçoit': 'Inactive — no album gets it',
  'Auto — choisi d’après la couverture : {n}': 'Auto — picked from the cover: {n}',
  'Auto — choisi d’après la couverture': 'Auto — picked from the cover',
  'Thème de l’album indisponible': 'Album theme unavailable',
  'Thème de l’album…': 'Album theme…',
  'Migration 248 pas encore appliquée': 'Migration 248 not applied yet',
  'Migration 244 pas encore appliquée': 'Migration 244 not applied yet',
  'Migration 246 pas encore appliquée': 'Migration 246 not applied yet',
  'Relancer la mise en page de cet album avec ces réglages': 'Rerun this album’s layout with these settings',
  'Teinte les lettres découpées, rubans, washi, pierres et papier du thème': 'Tints the theme’s cut-out letters, ribbons, washi, gems and paper',
  'lettres, rubans, washi, pierres et papier — choisie par album sur la page commande': 'letters, ribbons, washi, gems and paper — chosen per album',
  'Le thème de cet album (Auto = celui de la couverture)': 'This album’s theme (Auto = the cover’s)',
  'Appliquer :': 'Apply:',
  'Régénérer': 'Regenerate',
};
export default m;
